import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FormatParserService {

    apply(value: unknown, format: string | null): string {

        const fmt = format ?? '';
        const num = parseFloat(String(value));

        // Quita $, % y espacios para trabajar solo con la máscara
        const mask = fmt.replace(/[$%\s]/g, '');

        // Si tiene %, multiplica por 100
        const isPercent = fmt.includes('%');
        const absValue = isPercent ? Math.abs(num) * 100 : Math.abs(num);

        // Formatea según el locale del navegador
        const decimals = this.countDecimals(mask);
        const formatted = absValue.toLocaleString(undefined, {
            style: 'decimal',
            useGrouping: mask.includes(','),
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });

        // Ensambla: signo + prefijo ($) + número + sufijo (%)
        const prefix = fmt.includes('$') && !isPercent ? '$' : '';
        const suffix = isPercent ? '%' : '';
        const sign = num < 0 ? '-' : '';

        return `${sign}${prefix}${formatted}${suffix}`;
    }

    // Cuenta decimales en la máscara: #,##0.00 → 2
    private countDecimals(mask: string): number {
        const dotIndex = mask.lastIndexOf('.');
        if (dotIndex === -1) return 0;
        const match = mask.substring(dotIndex + 1).match(/^[0#]+/);
        return match ? match[0].length : 0;
    }
}